import actionTypes from '../actionTypes';

const initialState = {
  isLoading: true,
  config: {
    bffServices: {},
    tempToken: {}
  },
  error: null,
  visitType: null,
  region: null,
  myChartFDIURL: null,
  launchType: null,
  vveLibParams: {},
  banner: {
    displayBanner: false,
    alertType: null,
    title: null,
    body: null,
    hideAlertIcon: true
  },
  renewToken: null
};

const ConfigReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  switch (type) {
    case actionTypes.SAVE_PARAMS_FOR_FETCH_CONFIG:
      return {
        ...state,
        visitType: payload.visitType,
        region: payload.region,
        querystring: payload.querystring,
        myChartFDIURL: payload.myChartFDIURL,
        launchType: payload.launchType
      };
    case actionTypes.FETCH_CONFIG_START:
      return {
        ...state,
        isLoading: true
      };
    case actionTypes.FETCH_CONFIG_SUCCESS: {
      const launchtype = payload.launchType;
      delete payload.launchType;
      return {
        ...state,
        isLoading: false,
        config: payload,
        launchType: launchtype
      };
    }
    case actionTypes.FETCH_CONFIG_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload
      };
    case actionTypes.SET_VVE_LIBPARAMS:
      return {
        ...state,
        vveLibParams: payload
      };
    case actionTypes.SET_DISPLAY_BANNER_OPTIONS:
      return {
        ...state,
        banner: payload
      };
    case actionTypes.FETCH_RENEW_TOKEN_SUCCESS:
      return {
        ...state,
        renewToken: payload.pingToken
      };
    default:
      return state;
  }
};

export default ConfigReducer;
